import { z } from 'zod';

/**
 * Estructura de un ítem dentro del índice de búsqueda local.
 * Este objeto está optimizado para ser ligero y viajar en el Handshake Index.
 */
// Fix S1874: .uuid() deprecado en Zod v4, se usa regex con flag 'i' (case-insensitive)
const uuidRegex = /^[0-9a-f]{8}\b-[0-9a-f]{4}\b-[0-9a-f]{4}\b-[0-9a-f]{4}\b-[0-9a-f]{12}$/i;

export const SearchIndexItemSchema = z.object({
  id: z.string().regex(uuidRegex, { message: 'ID debe ser UUID v4/v7 válido' }),
  nombre: z.string(),
  titulo_principal: z.string().optional(),
  especialidad: z.string(),
  sub_especialidad: z.string().optional(),
  licencia_profesional: z.string().optional(),
  
  // Coordenadas para cálculo de distancia local (Estilo Facebook/Uber)
  lat: z.number(),
  lng: z.number(),
  distance_km: z.number().optional(), // Distancia calculada en tiempo real
  ciudad_id: z.number().optional(), // Para filtrado estricto por ciudad (Turismo Médico)
  
  // Metadatos de ranking
  reputacion_score: z.number().min(0).max(100).default(0),
  badge_recomendado: z.boolean().default(false),
  verificado: z.boolean().default(false),
  agenda_activa: z.boolean().default(false),
  disponibilidad_status: z.enum(['alta', 'baja', 'ninguna']).default('ninguna'),
  disponibilidad_texto: z.string().optional(),
  disponibilidad_cta: z.string().optional(),
  
  // Campos para FlexSearch (opcionalmente concatenados para búsqueda rápida)
  search_blob: z.string().optional(), 
  
  // UI Assets
  imagen_url: z.string().nullable().optional(),
});

export type SearchIndexItem = z.infer<typeof SearchIndexItemSchema>;

/**
 * Representa un Shard (Fragmento) del índice basado en cuadrículas.
 */
export interface SearchIndexShard {
  grid_id: string; // Ej: "10.4,-66.8" (lat,lng truncado)
  version: string; // Hash para cacheo inteligente
  items: SearchIndexItem[];
}

export type SearchFilterType = 'recomendado' | 'cercania' | 'reputacion' | 'disponibilidad';
